<template>
    <div id="tag-list">
        <div class="tag-carousel" ref="carousel">
            <v-btn
                v-for="(item, i) in tagList"
                :class="['tag-item', isTagsActive === i && 'active']"
                :key="i"
                @click="get_tags_schema(item.name, i)"
                v-if="i > 120 ? false : true"
            >
                {{ item.name }}</v-btn
            >
        </div>
        <AllTagsModal v-if="1" :data="tagList" @tagsClick="tags_modal_click" />
    </div>
</template>

<script>
import { tags } from "@/api/interface.js";
import { timeout } from "@/utils/util.js";
import AllTagsModal from "./all-tags-modal";
import { mapState, mapMutations } from "vuex";

export default {
    name: "tag-list",

    components: { AllTagsModal },
    data() {
        return {
            tagList: [],
            index: 0,
        };
    },
    computed: {
        ...mapState("mixins", ["isTagsActive"]),
    },
    created() {
        this.get_tags_data();
    },
    mounted() {
        this.$P.$on("resizeTagFlickity", () => this.resize_tag_flickity());
    },
    beforeDestroy() {},
    methods: {
        ...mapMutations("triggerEvtents", [
            "updateClearSearchCondition",
            "updateGetSchemaData",
            "updateInitSearchCondition",
        ]),
        ...mapMutations("search", ["updateSearchCondition"]),

        async get_tags_data() {
            let { data } = await tags();
            this.tagList = data;
            await timeout(800);
            this.tags_flickity();
        },

        tags_flickity() {
            let option = {
                freeScroll: true,
                contain: true,
                prevNextButtons: true,
                pageDots: false,
                selectedAttraction: 0.6,
                friction: 1,
                groupCells: "60%",
            };

            let slideshowEl = this.$refs.carousel;
            window.flickity = new Flickity(slideshowEl, option);

            //滑动时禁用 图片放大功能
            window.flickity.on("dragMove", () => {
                $(slideshowEl)
                    .find(".flickity-slider")
                    .css("pointer-events", "none");
            });

            window.flickity.on("dragEnd", () => {
                $(slideshowEl)
                    .find(".flickity-slider")
                    .css("pointer-events", "");
            });

            // window.flickity.updateSelectedSlide();

            // 改变左右箭头图标
            $(".flickity-prev-next-button")
                .html(
                    `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="24" height="24" viewBox="0 0 24 24"><path d="M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z" /></svg>`
                )
                .addClass("btn-shadow");
        },

        async get_tags_schema(tagsName, key) {
            if (this.isTagsActive === key) return;
            this.updateInitSearchCondition();
            this.$P.schemaType = "search";
            //  重置搜索条件
            this.updateClearSearchCondition();

            this.updateSearchCondition({
                keyword: String(tagsName).trim(),
                lang: this.$store.state.global.currentLang.lang,
            });

            this.updateGetSchemaData();
            await timeout(150);
            window.flickity.selectCell(key);

            this.$store.state.mixins.isTagsActive = key;
        },

        tags_modal_click(tagsName, key) {
            this.get_tags_schema(tagsName, key);
        },

        async resize_tag_flickity() {
            let oldBtnWidth = 0;
            this.$nextTick(async () => {
                await timeout(200);
                oldBtnWidth = sumBtnExtent();
                let timing = setInterval(async () => {
                    if (oldBtnWidth !== sumBtnExtent()) {
                        clearInterval(timing);
                        await timeout(500);
                        window.flickity && window.flickity.resize();
                    }
                }, 1200);
            });

            let sumBtnExtent = () => {
                let sumWidth = 0;
                for (let index = 0; index < 5; index++) {
                    return (sumWidth += $(".tag-carousel .tag-item")
                        .eq(index)
                        .width());
                }
            };
        },
    },
};
</script>

<style lang="scss">
#tag-list {
    width: 100%;
    position: relative;
    // overflow: hidden;

    .tag-carousel {
        height: 80px;
        outline: none;
        padding: {
            top: 18px;
            bottom: 20px;
            right: 56px;
        }

        &:not(.flickity-enabled) {
            width: 100%;
            overflow: hidden;
            @include flex();
            .tag-item {
                margin-right: 8px;
                height: 36px;
            }
        }
    }

    .flickity-viewport {
        cursor: move;
        cursor: grab;
        overflow: hidden;
        position: relative;

        .flickity-slider {
            position: absolute;
            width: 100%;
            height: 100%;
            @include flex();
        }
    }

    .tag-item {
        flex-shrink: 0;
        margin-right: 8px;
        font-size: 14px;
        padding: 9px 16px;
        background-color: $color-white;
        border: 1px solid rgba(#0063c4, 0.4);
        line-height: 1.2;
        border-radius: 36px;
        white-space: nowrap;
        transition: all 0.2s ease;

        &:hover,
        &.active {
            border-color: transparent;
            @include bgc();

            span {
                color: $color-white;
            }
        }
    }

    .flickity-button {
        position: absolute;
        top: 12px;
        z-index: 10;
        transition: all 0.35s ease;
        width: 48px;
        height: 48px;
        background-color: $color-white;
        border-radius: 50%;
        @include flex(center, center);

        &[disabled] {
            opacity: 0;
            visibility: hidden;
        }

        &.next {
            right: 56px;
            svg {
                transform: rotate(180deg);
            }
        }

        svg {
            transform: scale(1.1);
            path {
                opacity: 0.65;
            }
        }
    }

    .tags-modal-btn {
        position: absolute;
        right: 0;
        top: 12px;
    }
}
</style>
